import { render, staticRenderFns } from "./DOTSPATIENTMonthInfo.vue?vue&type=template&id=01bc2bc3&scoped=true"
import script from "./DOTSPATIENTMonthInfo.vue?vue&type=script&lang=js"
export * from "./DOTSPATIENTMonthInfo.vue?vue&type=script&lang=js"
import style0 from "./DOTSPATIENTMonthInfo.vue?vue&type=style&index=0&id=01bc2bc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc2bc3",
  null
  
)

export default component.exports